module.exports = __webpack_public_path__ + "static/ip-ikon9-4f67b1c6122e14ec1d1450b2c7e92ae7.png";